import type { ApiGetPatentBasicResponse, TransferPerson } from '@/infrastructure/api-functions/core-search-api/get-patent-basic-api';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatentTransferExtend, PatentTransferItem } from '../../types';
import type { GetPatentTransferDTO } from '../get-patent-transfer';

@injectable()
export class GetPatentTransferDTOImpl implements GetPatentTransferDTO {
    private _formatPerson(transferPerson: TransferPerson[]) {
        return transferPerson.map((item, index) => ({
            ...item,
            isLast: index === (transferPerson.length - 1),
        }));
    }
    

    public getPatentTransfer(input: ApiGetPatentBasicResponse['TRANSFER']): PatentTransferExtend {
        const transfer: PatentTransferExtend = {
            transferHistory: [],
        };

        if (!input?.length) return transfer;

        try {
            const formatted: PatentTransferItem[] = [];

            // 保留数组反转，确保从最新到最早的顺序
            const reversedInput = [...input].reverse();
            reversedInput.forEach((item, index) => {
                // 处理第一个元素的transfer_before（如果存在的话）
                if (index === 0 && item.transfer_before) {
                    formatted.push({ person: this._formatPerson(item.transfer_before) });
                }
    
                // 始终处理transfer_after
                formatted.push({
                    person: this._formatPerson(item.transfer_after),
                    date: item.prsd,
                });
            });
    
            transfer.transferHistory = formatted;
        } catch (error) {
            console.error(error);
        }

        return transfer;
    }
}
